import { useEffect } from 'react';
import { useState } from '@hookstate/core';
import { useMutation } from '@tanstack/react-query';

import { required, maxLength, validate } from '../../../utils/Validation';
import { stateToEntries, stateToObject } from '../../../utils/HookStatePlugins';
import { updateGroup } from '../server/requests';
import useResponseHandler from './useResponseHandler';

const initialState = {
    // avatar: '',
    groupName: '',
    description: '',
};
const validators = {
    description: [maxLength({ maxLength: 250 })],
};

const useGroupEditForm = ({ defaults = initialState }) => {
    const form = useState(initialState);
    const errors = useState({});
    const values = stateToObject(form);

    useEffect(
        () => {
            form.merge(defaults);
        },
        [defaults.groupName, defaults.description]
    );
    useEffect(
        () => {
            errors.set(validate(stateToObject(form), validators));
        },
        [form.description]
    );

    const hasErrors = () => {
        return stateToEntries(errors).some(([, error]) => Boolean(error));
    };

    // persistence
    const { handleResponse } = useResponseHandler({
        requestHandler: updateGroup,
        payload: values,
    });
    //
    const mutationFn = async () => {
        const res = await handleResponse();
    };

    const mutation = useMutation({
        mutationFn,
        enabled: !hasErrors(),
    });

    return {
        setter: (value) => form.merge(value),
        errors,
        values: form,
        hasErrors: hasErrors(),
        save: mutation.mutateAsync,
        status: mutation,
    };
};

export default useGroupEditForm;
